import { watch } from 'vue';
import type { RouteLocationNormalizedLoaded } from 'vue-router';
import type { SiteRealtimeScene } from './site-realtime';
import { setSiteRealtimeScene, setSiteRealtimeToken } from './site-realtime-hub';

/** 游戏详情页（内嵌 iframe 玩游戏）算游戏中，其余页面算大厅。 */
export function sceneOfRoute(route: Pick<RouteLocationNormalizedLoaded, 'name' | 'params'>): SiteRealtimeScene {
  const gameCode = route.name === 'gameDetails' ? String(route.params.id ?? '').trim() : '';
  return gameCode ? { gameCode, scene: 'GAME' } : { scene: 'LOBBY' };
}

/** 在应用壳里调用一次：登录凭证与当前页面同步到站点 WS，后台据此统计在线 / 游戏中 / 大厅。 */
export function useSiteRealtimePresence(
  token: () => string,
  route: RouteLocationNormalizedLoaded,
) {
  watch(token, (value) => setSiteRealtimeToken(value ?? ''), { immediate: true });
  watch(
    () => [route.name, route.params.id] as const,
    () => setSiteRealtimeScene(sceneOfRoute(route)),
    { immediate: true },
  );
}
